import React from 'react';
import { getIn, ErrorMessage } from "formik";
import TextError from '../../../../shared/components/error-message';

export default function InputText(props) {
  const {secondLabel, ...inputField} = props;
  const { field, form, type, placeholder, disabled, numberonly, hideerror } = inputField;

  const name = field.name;

  const NOT_NUMBER = /\D+/

  function getStyles(errors, touched, name) {
    if (getIn(errors, name) && getIn(touched, name)) {
      return {
        border: '1px solid #FF5151',
        background: '#fcd9d4'
      }
    }
  }

  return <React.Fragment>
    {!hideerror && <ErrorMessage name={name} render={TextError} />}
    <div className="formInput">
      <input
        {...inputField}
        id={name}
        {...field}
        className="input"
        style={getStyles(form.errors, form.touched, name)}
        type={type}
        placeholder={placeholder || ''}
        disabled={disabled}
        onInput={(e) => {
          props.onInput && props.onInput(e)
          if (!numberonly || numberonly == "false") return;
          e.target.value = e.target.value.replace(NOT_NUMBER, '')
        }}
      />
      <span className="formUnit">{secondLabel}</span>
    </div>
  </React.Fragment>
}
